class Tools {
  constructor() {
    this.regCheckFields = /\{([a-z_-]+)\}(\[?([0-9\,]+)?\])?/ig;
  }

  copy(object) {
    return JSON.parse(JSON.stringify(object));
  }


  toNatural(number) {
    return !Number.isNaN(+number) ? number < 0 ? 0 : number : number;
  }

  fixTo(float, digitsAfterDot = 3) {
    return float ? +float.toFixed(digitsAfterDot) : float;
  }

  htmlToElement(html) {
    let template = document.createElement('template');
    html = html.trim(); // Never return a text node of whitespace as the result
    template.innerHTML = html;
    return template.content && template.content.firstChild ? template.content.firstChild : template.firstElementChild;
  }

  sliceString(string, limit, start) {
    string = string || '';
    start = start || 0;
    limit = limit || 40;

    return string && string.length > limit ? string.slice(start, limit) : string;

  }

  stripTags(string) {
    if (string) {
      let div = document.createElement('div');
      div.innerHTML = string;
      return div.textContent || div.innerText || '';
    } else {
      return '';
    }
  }

  clearSelection() {
    if (window.getSelection) {
      if (window.getSelection().empty) {  // Chrome
        window.getSelection()
          .empty();
      } else if (window.getSelection().removeAllRanges) {  // Firefox
        window.getSelection()
          .removeAllRanges();
      }
    } else if (document.selection) {  // IE?
      document.selection.empty();
    }
  }

  /**
   * Cross Browser helper to addEventListener.
   *
   * @param {HTMLElement} obj The Element to attach event to.
   * @param {string} evt The event that will trigger the binded function.
   * @param {function(event)} fnc The function to bind to the element.
   * @return {boolean} true if it was successfuly binded.
   */
  addEventListener(obj, evt, fnc, options = false) {
    // W3C model
    evt = evt || [];
    if (!Array.isArray(evt)) {
      evt = [evt];
    }

    if (obj.addEventListener) {
      evt.map(function(eventName) {
        obj.addEventListener(eventName, fnc, options);
      });
      return true;
    }
    // Microsoft model
    else if (obj.attachEvent) {
      evt.map(function(eventName) {
        obj.attachEvent('on' + eventName, fnc);
      });
      return true;
      //    return obj.attachEvent('on' + evt, fnc);
    }
    return false;
  }

  addScript(id, link) {
    let js,
      d = document,
      fjs = d.getElementsByTagName('script')[0];
    if (d.getElementById(id)) {
      return d.getElementById(id);
    }
    js = d.createElement('script');
    js.id = id;
    js.src = link;
    fjs.parentNode.insertBefore(js, fjs);
    return js;
  }

  parseQueryOptions(queryString) {
    let query = {};
    let pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (let i = 0; i < pairs.length; i++) {
      let isArray = false;
      let pair = pairs[i].split('=');
      if (pair[0].indexOf('[') !== -1) {
        pair[0] = pair[0].split('[')[0];
        isArray = true;
      }
      if (isArray) {
        query[decodeURIComponent(pair[0])] = query[decodeURIComponent(pair[0])] || [];
      }
      let val = true;
      if (pair.length >= 2) {
        val = pair[1] === '' || pair[1].toLowerCase() === 'true' ? true :
          pair[1] === 'false' ? false :
            pair[1] ? decodeURIComponent(pair[1]) : true;
      }

      if (isArray) {
        query[decodeURIComponent(pair[0])].push(val);
      } else {
        query[decodeURIComponent(pair[0])] = val;
      }
    }
    return query;
  }

  toHHMMSS(inputSeconds) {
    if (inputSeconds <= 0) {
      return '00:00';
    }
    let sec_num = parseInt(inputSeconds, 10); // don't forget the second param
    let hours = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    let seconds = sec_num - (hours * 3600) - (minutes * 60);

    // if (hours < 10) {
    //   hours = '0' + hours;
    // }
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    if (seconds < 10) {
      seconds = '0' + seconds;
    }
    return/* hours + ':' +*/ minutes + ':' + seconds;
  }

}

export default new Tools();